/* THIS IS A GENERATED FILE. PLEASE DO NOT MODIFY!! */
import * as Types from '../../../../types/dashboard-core-gqlTypes.generated.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GetBbplMonitorStatusQueryVariablesGQLType = Types.Exact<{
  creditFacilityId: Types.Scalars['UUID'];
}>;


export type GetBbplMonitorStatusQueryGQLType = (
  { __typename?: 'Query' }
  & { bbplMonitorStatus: (
    { __typename?: 'BBPLMonitorStatus' }
    & Pick<Types.BbplMonitorStatusGQLType, 'borrowerId' | 'latestArtifactDocumentId' | 'latestArtifactDocumentVersion'>
    & { latestArtifactInstance?: Types.Maybe<(
      { __typename?: 'ReportingDateAndVersion' }
      & Pick<Types.ReportingDateAndVersionGQLType, 'reportingDate' | 'fileVersion'>
    )> }
  ) }
);

export type GetBbplMonitorInstancesQueryVariablesGQLType = Types.Exact<{
  creditFacilityId: Types.Scalars['UUID'];
  reportingDate: Types.Scalars['FullDateStr'];
  fileVersion: Types.Scalars['Int'];
}>;


export type GetBbplMonitorInstancesQueryGQLType = (
  { __typename?: 'Query' }
  & { bbplMonitorInstanceRecords: (
    { __typename?: 'BbplMonitorInstanceRecords' }
    & Pick<Types.BbplMonitorInstanceRecordsGQLType, 'artifactDocumentId'>
    & { artifactInstances: Array<(
      { __typename?: 'BbplMonitorInstance' }
      & Pick<Types.BbplMonitorInstanceGQLType, 'id' | 'instanceRecordString'>
    )> }
  ) }
);

export type GetBbplMonitorDocumentQueryVariablesGQLType = Types.Exact<{
  artifactDocumentId: Types.Scalars['UUID'];
  creditFacilityId: Types.Scalars['UUID'];
}>;


export type GetBbplMonitorDocumentQueryGQLType = (
  { __typename?: 'Query' }
  & { bbplMonitorArtifactDocumentInfo: (
    { __typename?: 'BbplMonitorArtifactDocumentInfo' }
    & Pick<Types.BbplMonitorArtifactDocumentInfoGQLType, 'artifactDocumentId' | 'artifactsDocumentString' | 'artifactDocumentVersion'>
  ) }
);

export type GetBbplMonitorUploadUploadSignedUrlQueryVariablesGQLType = Types.Exact<{
  serializedParams: Types.Scalars['String'];
}>;


export type GetBbplMonitorUploadUploadSignedUrlQueryGQLType = (
  { __typename?: 'Query' }
  & { getSignedUploadUrl: (
    { __typename?: 'PresignedPost' }
    & Pick<Types.PresignedPostGQLType, 'url' | 's3RequestFields' | 'queryResponseFields'>
  ) }
);

export type GetBbplMonitorUploadDownloadSignedUrlQueryVariablesGQLType = Types.Exact<{
  serializedParams: Types.Scalars['String'];
}>;


export type GetBbplMonitorUploadDownloadSignedUrlQueryGQLType = (
  { __typename?: 'Query' }
  & { getSignedDownloadUrls: Array<(
    { __typename?: 'UrlAndFilename' }
    & Pick<Types.UrlAndFilenameGQLType, 'url' | 'filename'>
  )> }
);


export const GetBbplMonitorStatusDocumentGQLType = gql`
    query getBBPLMonitorStatus($creditFacilityId: UUID!) {
  bbplMonitorStatus(creditFacilityId: $creditFacilityId) {
    borrowerId
    latestArtifactDocumentId
    latestArtifactDocumentVersion
    latestArtifactInstance {
      reportingDate
      fileVersion
    }
  }
}
    `;

/**
 * __useGetBbplMonitorStatusQuery__
 *
 * To run a query within a React component, call `useGetBbplMonitorStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBbplMonitorStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBbplMonitorStatusQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetBbplMonitorStatusQuery(baseOptions: Apollo.QueryHookOptions<GetBbplMonitorStatusQueryGQLType, GetBbplMonitorStatusQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBbplMonitorStatusQueryGQLType, GetBbplMonitorStatusQueryVariablesGQLType>(GetBbplMonitorStatusDocumentGQLType, options);
      }
export function useGetBbplMonitorStatusLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetBbplMonitorStatusQueryGQLType, GetBbplMonitorStatusQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBbplMonitorStatusQueryGQLType, GetBbplMonitorStatusQueryVariablesGQLType>(GetBbplMonitorStatusDocumentGQLType, options);
        }
export type GetBbplMonitorStatusQueryHookResult = ReturnType<typeof useGetBbplMonitorStatusQuery>;
export type GetBbplMonitorStatusLazyQueryGQLTypeHookResult = ReturnType<typeof useGetBbplMonitorStatusLazyQueryGQLType>;
export type GetBbplMonitorStatusQueryResultGQLType = Apollo.QueryResult<GetBbplMonitorStatusQueryGQLType, GetBbplMonitorStatusQueryVariablesGQLType>;
export const GetBbplMonitorInstancesDocumentGQLType = gql`
    query GetBBPLMonitorInstances($creditFacilityId: UUID!, $reportingDate: FullDateStr!, $fileVersion: Int!) {
  bbplMonitorInstanceRecords(
    creditFacilityId: $creditFacilityId
    reportingDate: $reportingDate
    fileVersion: $fileVersion
  ) {
    artifactDocumentId
    artifactInstances {
      id
      instanceRecordString
    }
  }
}
    `;

/**
 * __useGetBbplMonitorInstancesQuery__
 *
 * To run a query within a React component, call `useGetBbplMonitorInstancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBbplMonitorInstancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBbplMonitorInstancesQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      reportingDate: // value for 'reportingDate'
 *      fileVersion: // value for 'fileVersion'
 *   },
 * });
 */
export function useGetBbplMonitorInstancesQuery(baseOptions: Apollo.QueryHookOptions<GetBbplMonitorInstancesQueryGQLType, GetBbplMonitorInstancesQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBbplMonitorInstancesQueryGQLType, GetBbplMonitorInstancesQueryVariablesGQLType>(GetBbplMonitorInstancesDocumentGQLType, options);
      }
export function useGetBbplMonitorInstancesLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetBbplMonitorInstancesQueryGQLType, GetBbplMonitorInstancesQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBbplMonitorInstancesQueryGQLType, GetBbplMonitorInstancesQueryVariablesGQLType>(GetBbplMonitorInstancesDocumentGQLType, options);
        }
export type GetBbplMonitorInstancesQueryHookResult = ReturnType<typeof useGetBbplMonitorInstancesQuery>;
export type GetBbplMonitorInstancesLazyQueryGQLTypeHookResult = ReturnType<typeof useGetBbplMonitorInstancesLazyQueryGQLType>;
export type GetBbplMonitorInstancesQueryResultGQLType = Apollo.QueryResult<GetBbplMonitorInstancesQueryGQLType, GetBbplMonitorInstancesQueryVariablesGQLType>;
export const GetBbplMonitorDocumentDocumentGQLType = gql`
    query getBBPLMonitorDocument($artifactDocumentId: UUID!, $creditFacilityId: UUID!) {
  bbplMonitorArtifactDocumentInfo(
    artifactDocumentId: $artifactDocumentId
    creditFacilityId: $creditFacilityId
  ) {
    artifactDocumentId
    artifactsDocumentString
    artifactDocumentVersion
  }
}
    `;

/**
 * __useGetBbplMonitorDocumentQuery__
 *
 * To run a query within a React component, call `useGetBbplMonitorDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBbplMonitorDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBbplMonitorDocumentQuery({
 *   variables: {
 *      artifactDocumentId: // value for 'artifactDocumentId'
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetBbplMonitorDocumentQuery(baseOptions: Apollo.QueryHookOptions<GetBbplMonitorDocumentQueryGQLType, GetBbplMonitorDocumentQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBbplMonitorDocumentQueryGQLType, GetBbplMonitorDocumentQueryVariablesGQLType>(GetBbplMonitorDocumentDocumentGQLType, options);
      }
export function useGetBbplMonitorDocumentLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetBbplMonitorDocumentQueryGQLType, GetBbplMonitorDocumentQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBbplMonitorDocumentQueryGQLType, GetBbplMonitorDocumentQueryVariablesGQLType>(GetBbplMonitorDocumentDocumentGQLType, options);
        }
export type GetBbplMonitorDocumentQueryHookResult = ReturnType<typeof useGetBbplMonitorDocumentQuery>;
export type GetBbplMonitorDocumentLazyQueryGQLTypeHookResult = ReturnType<typeof useGetBbplMonitorDocumentLazyQueryGQLType>;
export type GetBbplMonitorDocumentQueryResultGQLType = Apollo.QueryResult<GetBbplMonitorDocumentQueryGQLType, GetBbplMonitorDocumentQueryVariablesGQLType>;
export const GetBbplMonitorUploadUploadSignedUrlDocumentGQLType = gql`
    query getBbplMonitorUploadUploadSignedUrl($serializedParams: String!) {
  getSignedUploadUrl(
    feature: "getBBPLMonitorUploadDestination"
    serializedParams: $serializedParams
  ) {
    url
    s3RequestFields
    queryResponseFields
  }
}
    `;

/**
 * __useGetBbplMonitorUploadUploadSignedUrlQuery__
 *
 * To run a query within a React component, call `useGetBbplMonitorUploadUploadSignedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBbplMonitorUploadUploadSignedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBbplMonitorUploadUploadSignedUrlQuery({
 *   variables: {
 *      serializedParams: // value for 'serializedParams'
 *   },
 * });
 */
export function useGetBbplMonitorUploadUploadSignedUrlQuery(baseOptions: Apollo.QueryHookOptions<GetBbplMonitorUploadUploadSignedUrlQueryGQLType, GetBbplMonitorUploadUploadSignedUrlQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBbplMonitorUploadUploadSignedUrlQueryGQLType, GetBbplMonitorUploadUploadSignedUrlQueryVariablesGQLType>(GetBbplMonitorUploadUploadSignedUrlDocumentGQLType, options);
      }
export function useGetBbplMonitorUploadUploadSignedUrlLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetBbplMonitorUploadUploadSignedUrlQueryGQLType, GetBbplMonitorUploadUploadSignedUrlQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBbplMonitorUploadUploadSignedUrlQueryGQLType, GetBbplMonitorUploadUploadSignedUrlQueryVariablesGQLType>(GetBbplMonitorUploadUploadSignedUrlDocumentGQLType, options);
        }
export type GetBbplMonitorUploadUploadSignedUrlQueryHookResult = ReturnType<typeof useGetBbplMonitorUploadUploadSignedUrlQuery>;
export type GetBbplMonitorUploadUploadSignedUrlLazyQueryGQLTypeHookResult = ReturnType<typeof useGetBbplMonitorUploadUploadSignedUrlLazyQueryGQLType>;
export type GetBbplMonitorUploadUploadSignedUrlQueryResultGQLType = Apollo.QueryResult<GetBbplMonitorUploadUploadSignedUrlQueryGQLType, GetBbplMonitorUploadUploadSignedUrlQueryVariablesGQLType>;
export const GetBbplMonitorUploadDownloadSignedUrlDocumentGQLType = gql`
    query getBbplMonitorUploadDownloadSignedUrl($serializedParams: String!) {
  getSignedDownloadUrls(
    feature: "bbplMonitorInstanceRecord"
    serializedParams: $serializedParams
  ) {
    url
    filename
  }
}
    `;

/**
 * __useGetBbplMonitorUploadDownloadSignedUrlQuery__
 *
 * To run a query within a React component, call `useGetBbplMonitorUploadDownloadSignedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBbplMonitorUploadDownloadSignedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBbplMonitorUploadDownloadSignedUrlQuery({
 *   variables: {
 *      serializedParams: // value for 'serializedParams'
 *   },
 * });
 */
export function useGetBbplMonitorUploadDownloadSignedUrlQuery(baseOptions: Apollo.QueryHookOptions<GetBbplMonitorUploadDownloadSignedUrlQueryGQLType, GetBbplMonitorUploadDownloadSignedUrlQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBbplMonitorUploadDownloadSignedUrlQueryGQLType, GetBbplMonitorUploadDownloadSignedUrlQueryVariablesGQLType>(GetBbplMonitorUploadDownloadSignedUrlDocumentGQLType, options);
      }
export function useGetBbplMonitorUploadDownloadSignedUrlLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetBbplMonitorUploadDownloadSignedUrlQueryGQLType, GetBbplMonitorUploadDownloadSignedUrlQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBbplMonitorUploadDownloadSignedUrlQueryGQLType, GetBbplMonitorUploadDownloadSignedUrlQueryVariablesGQLType>(GetBbplMonitorUploadDownloadSignedUrlDocumentGQLType, options);
        }
export type GetBbplMonitorUploadDownloadSignedUrlQueryHookResult = ReturnType<typeof useGetBbplMonitorUploadDownloadSignedUrlQuery>;
export type GetBbplMonitorUploadDownloadSignedUrlLazyQueryGQLTypeHookResult = ReturnType<typeof useGetBbplMonitorUploadDownloadSignedUrlLazyQueryGQLType>;
export type GetBbplMonitorUploadDownloadSignedUrlQueryResultGQLType = Apollo.QueryResult<GetBbplMonitorUploadDownloadSignedUrlQueryGQLType, GetBbplMonitorUploadDownloadSignedUrlQueryVariablesGQLType>;